import {compose, lensProp, over, set} from 'ramda';
import {createReducer, noopAction} from 'warped-reducers';
import {equal} from '../services/vessels.saga';
import {defaultTo} from '../utils/state';

export const baseLens = lensProp('vessels');

export const isPendingState = compose(
  baseLens,
  lensProp('isPending'),
  defaultTo(false),
);

export const listState = compose(
  baseLens,
  lensProp('list'),
  defaultTo([]),
);

export const {reducer, types, actions} = createReducer('vessels')({
  setIsPendingState: set(isPendingState),
  getVesselsList: noopAction,
  setVesselsList: payload => compose(
    set(listState, payload),
    set(isPendingState, false),
  ),
  updateVessel: noopAction,
  setVessel: payload => over(listState, list => list.map(item => (
    equal(item, payload)
      ? Object.assign({}, item, payload)
      : item
  )))
});
